import cn from 'classnames';
import Image from 'next/image';

import { Link } from '@lib/navigation';
import { Author } from 'types/author';

interface ArticleAuthorProps {
  className?: string;
  author: Author;
  articleDate?: string;
}
export default function ArticleAuthor({ className, author, articleDate }: ArticleAuthorProps) {
  const fullName = `${author.firstName} ${author.lastName}`;

  return (
    <div className={cn('group flex items-center justify-between', className)}>
      <Link href={`/user/${author.slug}`} className="flex items-center">
        <Image
          className="mr-3 h-8 w-8 rounded-full bg-premium-100 transition-transform group-hover:scale-110 lg:h-12 lg:w-12"
          src={author.avatar || '/static/default-avatar.png'}
          width={48}
          height={48}
          alt={fullName}
        />
        <div className="flex flex-col text-xs">
          <p className="mr-2 text-black dark:text-white">{fullName}</p>
          <p className="text-premium-900 dark:text-orange-500">
            {[author.userCaption, articleDate].filter((q) => q).join(' | ')}
          </p>
        </div>
      </Link>
    </div>
  );
}
